import { render, staticRenderFns } from "./VipLevels.vue?vue&type=template&id=d2b4862e&scoped=true&"
import script from "./VipLevels.vue?vue&type=script&lang=js&"
export * from "./VipLevels.vue?vue&type=script&lang=js&"
import style0 from "./VipLevels.vue?vue&type=style&index=0&id=d2b4862e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b4862e",
  null
  
)

export default component.exports